import type { MasteryVisualLevel } from '@/lib/mastery';
import type { FirstPracticeChoice } from '@/lib/first-practice';

export type RepertoireEntryFormDirtyState = {
  visualMastery: MasteryVisualLevel;
  queueStatusId: string;
  keyId: string | null;
  practiceTempoRaw: string;
  performanceTempoRaw: string;
  notesRaw: string;
  firstPracticeChoice: FirstPracticeChoice | null;
  firstPracticeCustomDate: string | null;
};

export type RepertoireEntryFormDirtyInputs = {
  current: RepertoireEntryFormDirtyState;
  initial: RepertoireEntryFormDirtyState;
};

export function isRepertoireEntryFormDirty(inputs: RepertoireEntryFormDirtyInputs): boolean {
  const { current, initial } = inputs;
  if (current.notesRaw.trim() !== initial.notesRaw.trim()) return true;
  if (current.visualMastery !== initial.visualMastery) return true;
  if (current.queueStatusId !== initial.queueStatusId) return true;
  if (current.keyId !== initial.keyId) return true;
  if (current.practiceTempoRaw !== initial.practiceTempoRaw) return true;
  if (current.performanceTempoRaw !== initial.performanceTempoRaw) return true;
  if (current.firstPracticeChoice !== initial.firstPracticeChoice) return true;
  if (current.firstPracticeCustomDate !== initial.firstPracticeCustomDate) return true;
  return false;
}
